import { useT } from '../i18n'

/** Blättern in Trefferlisten. Zwei Knöpfe und eine Standortangabe reichen. */
export function Pagination({
  seite,
  seiten,
  onWechsel,
}: {
  seite: number
  seiten: number
  onWechsel: (seite: number) => void
}) {
  const t = useT()
  if (seiten <= 1) return null

  return (
    <nav className="blaettern" aria-label={t('blaettern.aria')}>
      <button
        className="knopf knopf-schlicht"
        type="button"
        disabled={seite <= 1}
        onClick={() => onWechsel(seite - 1)}
      >
        {t('blaettern.zurueck')}
      </button>
      <span aria-live="polite">{t('blaettern.seiteVon', { seite, seiten })}</span>
      <button
        className="knopf knopf-schlicht"
        type="button"
        disabled={seite >= seiten}
        onClick={() => onWechsel(seite + 1)}
      >
        {t('blaettern.weiter')}
      </button>
    </nav>
  )
}
